import { Dispatch, SetStateAction, useState } from 'react';
import { QueryObserverResult } from 'react-query';

import { EyeIcon } from '../../../assets/svg';
import { EyeIconOff } from '../../../assets/svg';
import { CopyIcon } from '../../../assets/svg';
import { Modal } from '../../../components/modal';
import { Status } from '../../../components/status';
import { ETPayTable } from '../../../components/table';
import { CommerceData } from '../../../models/commerce';
import { PaymentStatus, Status as StatusType } from '../../../models/common-payments';
import { ColumnInterface, Filters, Pagination } from '../../../models/table';
import { fillStatesWithZeros } from '../../../utils/states';
import { ModalMerchantStatus } from '../actived-modal';
import { ButtonEdit, ButtonsContainer, ItemText, StatusContainer, Text } from './styles';
interface CommerceMxTableProps {
	data: CommerceData[];
	isLoading?: boolean;
	stateList: PaymentStatus[];
	filters: Filters;
	onFilterChange: Dispatch<SetStateAction<Filters>>;
	pagination: Pagination;
	setPagination: Dispatch<SetStateAction<Pagination>>;
	totalResults?: number;
	refetch: () => Promise<QueryObserverResult<any, unknown>>;
}
interface Status {
	status: string;
	message: string;
}

export interface ModalProps {
	title: string;
	loader: boolean;
	show: boolean;
	url: string;
	typeModal: string;
	merchantCode: string;
}

const defaultModal: ModalProps = {
	title: '',
	loader: false,
	show: false,
	url: '',
	typeModal: 'default',
	merchantCode: '',
};

const CommerceTable = ({
	data,
	isLoading,
	stateList,
	filters,
	onFilterChange,
	pagination,
	setPagination,
	totalResults,
	refetch,
}: CommerceMxTableProps) => {
	const [modal, setModal] = useState<ModalProps>(defaultModal);

	const commerceStates = ['actived', 'inactived'];

	const columns: ColumnInterface<CommerceData>[] = [
		{
			sortField: true,
			title: 'Nombre del comercio',
			propertyName: 'name',
			cellRender: ({ merchantname }) => (
				<ItemText>
					<Text>{merchantname}</Text>
				</ItemText>
			),
		},
		{
			title: 'Merchant code',
			propertyName: 'merchantcode',
			cellRender: ({ merchantcode }) => (
				<ItemText>
					<Text>{merchantcode}</Text>
				</ItemText>
			),
		},
		{
			title: 'Merchant token',
			propertyName: 'merchanttoken',
			cellRender: ({ merchanttoken }) => (
				<ItemText>
					<Text>{merchanttoken.substring(0, 10) + '...'}</Text>
					<ButtonEdit onClick={() => handleCopyToClipboard(merchanttoken)}>
						<CopyIcon />
					</ButtonEdit>
				</ItemText>
			),
		},
		{
			title: 'Merchant padre',
			propertyName: 'merchantfather',
			cellRender: ({ enterprise }) => (
				<ItemText>
					<Text>{enterprise}</Text>
				</ItemText>
			),
		},
		{
			title: 'Estatus',
			propertyName: 'finalstatus',
			align: 'center',
			cellRender: ({ status }) => {
				return (
					<>
						<MerchantStatusComponent finalstatus={status} />
					</>
				);
			},
		},
		{
			title: '',
			propertyName: 'edit',
			align: 'center',
			cellRender: ({ status, merchantcode }) => {
				return (
					<>
						<ButtonsContainer>
							{/*<ButtonEdit>
								<EditIcon />
							</ButtonEdit>*/}
							<ButtonEdit
								onClick={() =>
									setModal({
										...modal,
										title: status == 'actived' ? 'Desactivar comercio' : 'Activar comercio',
										show: true,
										typeModal: status == 'actived' ? 'activedMerchant' : 'inactivedMerchant',
										merchantCode: merchantcode,
									})
								}
							>
								{status == 'actived' ? <EyeIconOff /> : <EyeIcon />}
							</ButtonEdit>
						</ButtonsContainer>
					</>
				);
			},
		},
	];
	const handleCopyToClipboard = (text: string) => {
		navigator.clipboard.writeText(text);
	};

	const MerchantStatusComponent = ({ finalstatus }: { finalstatus: StatusType }) => {
		return (
			<StatusContainer>
				<Status status={finalstatus} borderFull />
			</StatusContainer>
		);
	};

	const handleCloseModal = (refresh?: boolean) => {
		setModal(defaultModal);
		if (refresh) {
			refetch();
		}
	};

	return (
		<>
			{modal.show && (
				<Modal
					title={modal.title}
					show={modal.show}
					onClose={handleCloseModal}
					allowCloseModal={!modal.loader}
				>
					<>
						{(modal.typeModal == 'activedMerchant' || modal.typeModal == 'inactivedMerchant') && (
							<ModalMerchantStatus
								statusMerchant={modal.typeModal == 'activedMerchant' ? true : false}
								merchantCode={modal.merchantCode}
								setShowFinalizedModal={() => handleCloseModal(true)}
							/>
						)}
					</>
				</Modal>
			)}

			<ETPayTable<CommerceData>
				data={data}
				isLoading={!!isLoading}
				columns={columns}
				hasFilters
				allowExport
				stateList={fillStatesWithZeros({ states: commerceStates, stateList })}
				filters={filters}
				onFilterChange={onFilterChange}
				hasSearch
				hasPagination
				allowCustomFilter
				totalResults={totalResults}
				pagination={pagination}
				setPagination={setPagination}
				statusContent={[
					['actived', 'Activos'],
					['inactived', 'Inactivos'],
				]}
			/>
		</>
	);
};

export { CommerceTable };
